<div class=" mt-4">
    <section>
        <div class="scrollmenu">
            <a [routerLink]="['/pos/businessinfo']"> Business-info </a>
            <a [routerLink]="['/pos/customer/new']"> Customer </a>
            <a [routerLink]="['/pos/Employee/new']"> Employee </a>
            <a [routerLink]="['/pos/orders/new']"> Orders</a>
            <a [routerLink]="['/pos/taxfee/new']"> Tax Fee </a>
            <a [routerLink]="['/pos/category/new']"> Item-Category </a>
            <a [routerLink]="['/pos/item/new']"> Items </a>
            <a routerLinkActive = "active" class="active menu" [routerLink]="['/pos/businesshour/new']"> Business-Hours </a>
            <!-- <a [routerLink]="['/pos/order/new']"> Order </a>
            <a [routerLink]="['/pos/orderreceipt/new']"> Order Receipt </a>
            <a [routerLink]="['/pos/payment/new']"> Payment </a>
            <a [routerLink]="['/pos/paymentrecipt/new']"> Payment Receipt </a>
            <a [routerLink]="['/pos/tip/new']"> Tips </a> -->

            <!--  <a [routerLink]="['/pos/orderregister']"> Order Register </a>  -->
            <!--  <a [routerLink]="['/pos/ordertype/new']"> Order Type </a> -->
            <!--   <a [routerLink]="['/pos/tender/new']">  Tender </a>  -->
        </div>

    </section>
    <section class="mt-2">
        <div class="">
            <div class="row">
                <div class="col-md-12">
                    <div class="text-right py-2">
                        <button class="btn dash-btns" [routerLink]="['/pos/businesshour/manage']">Manage Business
                            Hours</button>

                    </div>
                </div>
                <div class="col-md-7">
                    <div class="card-1">
                        <div class="row">
                            <div class="col-md-12">
                                <!-- <div class="text-center mb-5">
                                    <img src="assets/img/new/view-trans.svg" />
                                </div> -->
                                <div class="text-center">
                                    <div class="col-md-12" *ngIf="isNewbusiness">
                                        <a class="view-h gary-t  ">Lets create a New Business Hours. </a>
                                    </div>
                                    <div class="col-md-12" *ngIf="isUpdatebusiness">
                                        <a class="view-h gary-t  ">Lets Update Business Hours here.</a>
                                    </div>

                                </div>

                                <div class="py-3">

                                    <div class="col-md-12" *ngIf="isNewbusiness">
                                        <form #fnewprepaidcard="ngForm">
                                            <div>
                                                <form #form="ngForm" class="addpaynow">
                                                    <div class="form-group formgroup-tm">

                                                        <div class="row pt-2">

                                                            <div class="col-md-12">
                                                               
                                                                <div class="form-group formgroup-tm">
                                                                    <!-- <input type="text" placeholder="Week Day " id="WeekDay" name="WeekDay" [formControl]="WeekDay"
                                                                      required> -->
                                                                      <label class="customlabel">Week Day*</label>
                                                                      <div class="selectcustom mb-0">
                                                                        <ngx-select [items]="weekdays"
                                                                        placeholder="Week Day" id="WeekDay"
                                                                        name="WeekDay" [formControl]="WeekDay" (select)="selectweekdays()">
                                                                    </ngx-select>
                                                                      </div>
                                                                


                                                                </div>
                                                                <span class="text-danger" *ngIf="weekdayserrormessage">WeekDay is already exist</span>
                                                                <span class="text-danger"
                                                                    *ngIf="WeekDay.invalid && (WeekDay.dirty || WeekDay.touched)">{{weekdayerror()}}</span>
                                                            </div>
                                                        </div>

                                                        <div class="row pt-2">

                                                            <div class="col-md-12">
                                                              
                                                                <div class="form-group formgroup-tm">
                                                                    <label class="customlabel">Hour Type *</label>
                                                                    <input class="formcontrol-user1 form-control"
                                                                        type="text" placeholder="Hour Type   "
                                                                        id="HourType" name="HourType"
                                                                        [formControl]="HourType" required>
                                                                    <!-- <mat-error *ngIf="HourType.invalid">{{hourtypeerror()}}</mat-error>  -->

                                                                </div>
                                                                <span class="text-danger"
                                                                    *ngIf="HourType.invalid && (HourType.dirty || HourType.touched)">{{hourtypeerror()}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="row pt-2">

                                                            <div class="col-md-12">
                                                             
                                                                <div class="form-group formgroup-tm">
                                                                    <label class="customlabel">Time From*</label>
                                                                    <input type="text"
                                                                        class="formcontrol-user1 form-control"
                                                                        placeholder="Time From" id="TimeFrom"
                                                                        name="TimeFrom" [formControl]="TimeFrom"
                                                                        required>
                                                                    <!-- <mat-error *ngIf="TimeFrom.invalid">{{timefromerror()}}</mat-error> -->
                                                                </div>

                                                                <span class="text-danger"
                                                                    *ngIf="TimeFrom.invalid && (TimeFrom.dirty || TimeFrom.touched)">{{timefromerror()}}</span>

                                                            </div>
                                                        </div>

                                                        <div class="row pt-2">

                                                            <div class="col-md-12">
                                                               
                                                                <div class="form-group formgroup-tm">
                                                                    <label class="customlabel">Time To *</label>
                                                                    <input class="formcontrol-user1 form-control"
                                                                        type="text" placeholder="Time To" id="TimeTo"
                                                                        name="TimeTo" maxlength="10"
                                                                        [formControl]="TimeTo">
                                                                    <!-- <mat-error *ngIf="TimeTo.invalid">{{timetoerror()}}</mat-error> -->
                                                                </div>
                                                                <span class="text-danger"
                                                                    *ngIf="TimeTo.invalid && (TimeTo.dirty || TimeTo.touched)">{{timetoerror()}}</span>
                                                            </div>
                                                        </div>

                                                        <div class="text-right pt-3">
                                                            <button class="btn dash-btns" type="button"
                                                                id="businesshourse" color="primary"
                                                                [disabled]="TimeTo.invalid || TimeFrom.invalid || HourType.invalid || WeekDay.invalid ||weekdayserrormessage"
                                                                (click)="newBusinesshours()">Submit</button>

                                                        </div>

                                                    </div>
                                                </form>
                                            </div>

                                        </form>
                                    </div>
                                    <div class="col-md-12" *ngIf="isUpdatebusiness">
                                        <form #fnewprepaidcard="ngForm">
                                            <div>
                                                <form #form="ngForm" class="addpaynow">
                                                    <div class="form-group formgroup-tm">

                                                        <div class="row pt-2">

                                                            <div class="col-md-12">
                                                               
                                                                <div class="form-group formgroup-tm">
                                                                    <!-- <input type="text" placeholder="Week Day " id="WeekDay"  name="WeekDay"   [formControl]="WeekDay" [(ngModel)]="rows.WeekDay"
                                                                      required> -->
                                                                      <label class="customlabel">Week Day*</label>
                                                                      <div class="selectcustom mb-0">
                                                                        <ngx-select [items]="weekdays"
                                                                        placeholder="Week Day" id="WeekDay"
                                                                        name="WeekDay" [formControl]="WeekDay"
                                                                        (select)="onKey()" [(ngModel)]="rows.WeekDay" (select)="selectweekdays()">
                                                                    </ngx-select>
                                                                      </div>
                                                         


                                                                </div>
                                                                <span class="text-danger" *ngIf="weekdayserrormessage">WeekDay is already exist</span>
                                                                <span class="text-danger"
                                                                    *ngIf="WeekDay.invalid && (WeekDay.dirty || WeekDay.touched)">{{weekdayerror()}}</span>
                                                            </div>
                                                        </div>
                                                        <input type="hidden" class="formcontrol-user1 form-control"
                                                            [(ngModel)]="rows.Id" id="id" name="id" [formControl]="id">
                                                        <!-- <input type="hidden" [(ngModel)]="rows.DateTime" id="datetime" name="datetime"  [formControl]="dateTime" > -->
                                                        <input type="hidden" [(ngModel)]="rows.DateTime" id="date"
                                                            name="date" [formControl]="date">

                                                        <div class="row pt-2">

                                                            <div class="col-md-12">
                                                               
                                                                <div class="form-group formgroup-tm">
                                                                    <label class="customlabel">Hour Type *</label>
                                                                    <input class="formcontrol-user1 form-control"
                                                                        type="text" placeholder="Hour Type   "
                                                                        (keydown)="onKey()" id="HourType"
                                                                        name="HourType" [formControl]="HourType"
                                                                        [(ngModel)]="rows.HourType " required>
                                                                    <!-- <mat-error *ngIf="HourType.invalid">{{hourtypeerror()}}</mat-error>  -->

                                                                </div>
                                                                <span class="text-danger"
                                                                    *ngIf="HourType.invalid && (HourType.dirty || HourType.touched)">{{hourtypeerror()}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="row pt-2">

                                                            <div class="col-md-12">
                                                                
                                                                <div class="form-group formgroup-tm">
                                                                    <label class="customlabel">Time From*</label>
                                                                    <input type="text"
                                                                        class="formcontrol-user1 form-control"
                                                                        placeholder="Time From" id="TimeFrom"
                                                                        name="TimeFrom" (keydown)="onKey()"
                                                                        [formControl]="TimeFrom"
                                                                        [(ngModel)]="rows.TimeFrom " required>
                                                                    <!-- <mat-error *ngIf="TimeFrom.invalid">{{timefromerror()}}</mat-error> -->
                                                                </div>

                                                                <span class="text-danger"
                                                                    *ngIf="TimeFrom.invalid && (TimeFrom.dirty || TimeFrom.touched)">{{timefromerror()}}</span>

                                                            </div>
                                                        </div>

                                                        <div class="row pt-2">
                                                            <div class="col-md-12">
                                                              
                                                                <div class="form-group formgroup-tm">
                                                                    <label class="customlabel">Time To *</label>
                                                                    <input type="text"
                                                                        class="formcontrol-user1 form-control"
                                                                        placeholder="Time To" id="TimeTo" name="TimeTo"
                                                                        (keydown)="onKey()" maxlength="10"
                                                                        [formControl]="TimeTo"
                                                                        [(ngModel)]="rows.TimeTo ">
                                                                    <!-- <mat-error *ngIf="TimeTo.invalid">{{timetoerror()}}</mat-error> -->
                                                                </div>
                                                                <span class="text-danger"
                                                                    *ngIf="TimeTo.invalid && (TimeTo.dirty || TimeTo.touched)">{{timetoerror()}}</span>
                                                            </div>
                                                        </div>








                                                        <div class="text-right pt-3">
                                                            <button class="btn dash-btns" type="button"
                                                                id="businesshourse" color="primary"
                                                                [disabled]="WeekDay.invalid || TimeFrom.invalid || HourType.invalid || WeekDay.invalid ||!isReadytoUpdatebusinesshour ||weekdayserrormessage"
                                                                (click)="updatebusinesshours()">Update</button>
                                                            <!-- [disabled]="TimeTo.invalid || TimeFrom.invalid || HourType.invalid || WeekDay.invalid"  -->

                                                        </div>

                                                    </div>
                                                </form>
                                            </div>

                                        </form>
                                    </div>






                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="card p-2">
                        <div class="text-center">
                           <img src="https://fastswiff.com/assets/img/easytouse.png"   class="w-100" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</div>






<!-- 
<section class="content profile-page">
    <div class="block-header">
        <div class="">
            <div class="row ">
                <div class="col-md-12  p-0">
                    <h2 class="poppins font-weight-bold pl-2"> Business</h2>
                </div>
                <div class=" col-md-5 px-6 col-sm-12 p-0">

                    <div class="breadcrumb flat">
                        <a [routerLink]="['/pos']">
                            
                            Home
                        </a>
                        <a href="#" class="active">New Business Hours</a>
                    </div>
                </div>
                <div class="col-md-7">
                    <div class="float-right">
                      
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="container">
        <div class="row">
            <div class="col-md-12 p-0">
                <div class=" card px-2 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
                    <div class="row mx-0">
                      

                    </div>
                    <div class="row mx-0">

                      


                        <div class="col-md-5">
                            <div class="b">
                                <img src="assets/img/payment-solutions.png" alt="Tips"
                                    style="display: block; width: 100%;">
                            </div>

                        </div>



                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->